import * as actions from './actions'

const catalogFederalEntitiesModule = {
    namespaced: true,
    actions,
}

export default catalogFederalEntitiesModule
